import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const mins = (t) => { const [h, m] = String(t || "").split(":").map(Number); return Number.isFinite(h) ? h * 60 + (m || 0) : null; };
const nowMins = () => { const s = new Date().toLocaleTimeString("en-GB", { timeZone: "Europe/London", hour: "2-digit", minute: "2-digit", hour12: false }); return mins(s); };

export const nowNext = (lessons, at) => {
  const ls = (lessons ?? []).filter((l) => mins(l.start) !== null).sort((a, b) => mins(a.start) - mins(b.start));
  if (!ls.length || at < mins(ls[0].start) - 60) return null;
  for (let i = 0; i < ls.length; i += 1) {
    const s = mins(ls[i].start);
    const e = mins(ls[i].end) ?? (ls[i + 1] ? mins(ls[i + 1].start) : s + 50);
    if (at < s) return { kind: "next", l: ls[i], in: s - at };
    if (at < e) return { kind: "now", l: ls[i], left: e - at, after: ls[i + 1] };
  }
  return null;
};

export const NowNextBanner = ({ today }) => {
  const [at, setAt] = useState(nowMins());
  useEffect(() => { const t = setInterval(() => setAt(nowMins()), 30000); return () => clearInterval(t); }, []);
  if (!today || today.closed) return null;
  const s = nowNext(today.lessons, at);
  if (!s) return null;
  const room = (l) => (l?.room ? ` · ${l.room}` : "");
  return (
    <div data-testid="now-next-banner" className="flex items-center gap-3 rounded-2xl border border-gold-400/50 bg-gold-400/10 px-4 py-3">
      <Clock className="w-5 h-5 shrink-0 text-gold-300" />
      <p className="text-sm text-slate-900">
        {s.kind === "next"
          ? <><b>Next: {s.l.subject}</b> in {s.in} min{room(s.l)}</>
          : <><b>Now: {s.l.subject}</b>{room(s.l)} · {s.left} min left{s.after ? <span className="text-slate-600"> · then {s.after.subject}{room(s.after)}</span> : null}</>}
      </p>
    </div>
  );
};
